import PopUpBase from '@components/PopUpBase';
import { CameraPhotoType } from '@EcamModel/controllers/ICameraHttpController';
import { CameraPhotos } from '@EcamModel/model';
import { IPopUp } from '@hooks/usePopUp';
import { Button, Stack, Typography } from '@mui/material';
import { useCameraDetailContext } from '@pages/cameras/hook/CameraDetailsProvider';
import LivePhotos from '@pages/cameras/live-photos/components';

type Props = IPopUp & {
    selectedItemsLivePhotos: CameraPhotos | null;
    onSelectedItemLivePhoto?: (item: CameraPhotos | null) => void;
    photoType: CameraPhotoType;
    title: string;
};

export default function PopupSetCameraPhoto(props: Props) {
    const { open, selectedItemsLivePhotos, onSelectedItemLivePhoto, onClose, onConfirm, title } = props;
    const { camera } = useCameraDetailContext();

    return (
        <PopUpBase
            title={<Typography variant="h4">Set {title} photo</Typography>}
            dialogProps={{
                fullWidth: true,
                maxWidth: 'lg',
                sx: {
                    '& .MuiDialog-paper': {
                        borderRadius: '10px',
                    },
                },
            }}
            open={open}
            onClose={onClose}
            hideConfirm
            minWidthButton={130}
            desc={
                <LivePhotos
                    camera={camera}
                    isCheckScrollPopup
                    selectedItemsLivePhotos={selectedItemsLivePhotos}
                    onSelectedItemLivePhoto={(item) => onSelectedItemLivePhoto?.(item)}
                    defaultTime
                />
            }
            customActions={
                <Stack mt={3} direction={'row'} width="100%" justifyContent="space-between">
                    <Button
                        sx={{ minWidth: 130 }}
                        variant="cancel"
                        onClick={() => {
                            props.onClose?.();
                            onSelectedItemLivePhoto?.(null);
                        }}
                    >
                        Cancel
                    </Button>
                    <Button
                        sx={{ minWidth: 130 }}
                        variant={'contained'}
                        disabled={!selectedItemsLivePhotos}
                        onClick={onConfirm}
                    >
                        Save
                    </Button>
                </Stack>
            }
        />
    );
}
